import { __awaiter, __generator } from "tslib";
export default [
    {
        id: '@mc-business-object',
        path: '/mc-business-object',
        ref: '/',
        onload: function () { return import('./ProviderContainer'); },
        onbefore: function (app) { return __awaiter(void 0, void 0, void 0, function () {
            var modelList;
            return __generator(this, function (_a) {
                modelList = require('./model').modelList;
                app.collection.register(modelList);
                return [2];
            });
        }); },
    },
    {
        point: '@@layers',
        prefix: '@mc-business-object',
        onload: function () { return import('./layers'); },
    },
];
